/**
 * @generated SignedSource<<8fde38c8a2efdeffbc78e1dc0426d683>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type companiesWithoutActiveSubscriptions_Query$variables = {};
export type companiesWithoutActiveSubscriptions_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"companiesWithoutActiveSubscriptions_viewer">;
  } | null;
};
export type companiesWithoutActiveSubscriptions_Query = {
  variables: companiesWithoutActiveSubscriptions_Query$variables;
  response: companiesWithoutActiveSubscriptions_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "control_companies_without_active_subscriptions"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"control_companies_without_active_subscriptions\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "companiesWithoutActiveSubscriptions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "companiesWithoutActiveSubscriptions_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "companiesWithoutActiveSubscriptions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlCompaniesWithoutActiveSubscriptionsType",
                "kind": "LinkedField",
                "name": "companiesWithoutActiveSubscriptions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastSessionDate",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8012098641c9961fc40c98f0b7a424d",
    "id": null,
    "metadata": {},
    "name": "companiesWithoutActiveSubscriptions_Query",
    "operationKind": "query",
    "text": "query companiesWithoutActiveSubscriptions_Query {\n  viewer {\n    actualPersonId\n    component(name: \"control_companies_without_active_subscriptions\")\n    ...companiesWithoutActiveSubscriptions_viewer\n    id\n  }\n}\n\nfragment companiesWithoutActiveSubscriptions_viewer on Viewer {\n  id\n  actualPersonId\n  missionControlData {\n    id\n    companiesWithoutActiveSubscriptions {\n      id\n      companyId\n      name\n      tier\n      createdAt\n      updatedAt\n      lastSessionDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c77e943620e2c259673d76c46c5b1ad";

export default node;
